export const GET_SIGNATURE_MEMBER_INFO = 'GET_SIGNATURE_MEMBER_INFO';
export const GET_SIGNATURE_MEMBER_INFO_SUCCESS = 'GET_SIGNATURE_MEMBER_INFO_SUCCESS';
